<span [ngClass]="showAsBadge ? 'badge badge-secondary status-padding' : 'delivery-contact-badge'">
  {{badgeText}}
</span>
